import Service from "../../../Services/index";

const FactorialMaterial = {
    namespaced: true,
    state: {
        factorialMaterialList: [],
        form:{
            id: null,
            name : "",
            source_id : "",
            quantity : 0,
            vendor : ''
        },
        search:{
            name: "",
            name_on_select: "",
            source_id : "",
        },
        searchWithSpecial:{
            name: "",
            name_on_select: "",
            source_id : "",
            special : "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        list:[],
        productTypeSpecial:[],
    },
    mutations: {
        SET_LIST_FACTORY: (state, res) => {
            state.list = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_FACTORIAL_MATERIAL_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA : (state)=>{
            state.form = {
                id: null,
                name : "",
                source_id : "",
                quantity : 0,
            }
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                name: "",
                source_id : "",
            }
        },
        GET_PRODUCT_SPECIAL: (state, res) => {
            state.productTypeSpecial = res;
        },
    },
    actions: {
        getProductAll({ commit }) {
            return Service.FactorialMaterial.getProductAll()
        },
        productTypeSpecial({ commit }) {
            return Service.FactorialMaterial.productTypeSpecial().then(response => {
                commit("GET_PRODUCT_SPECIAL", response);
            });
        },
        setFactorialMaterial({ commit }, page) {
            return Service.FactorialMaterial.getFactorialMaterial(page).then(res=>{
                commit('SET_LIST_FACTORY',res);
            });
        },
        saveFactorialMaterial({commit},data){
            if(!data.id){
                return Service.FactorialMaterial.createFactorialMaterial(data);
            }
            else{
                return Service.FactorialMaterial.updateFactorialMaterial(data.id,data);
            }
        },
        showFactorialMaterialByID({commit},id){
            return Service.FactorialMaterial.showFactorialMaterial(id).then(res=>{
                commit("GET_FACTORIAL_MATERIAL_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.FactorialMaterial.deleteFactorialMaterial(id)
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit},data){
            return Service.FactorialMaterial.searchFactorialMaterial(data).then(res=>{
                commit('SET_LIST_FACTORY',res);
                return res
            });
        },
        searchWithSpecial({commit},data){
            return Service.FactorialMaterial.searchWithSpecial(data).then(res=>{
                commit('SET_LIST_FACTORY',res);
                return res
            });
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({ commit }) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default FactorialMaterial;
